import { NoElements } from "../../../components/no-elements";

export const NoWallets = () => <NoElements item="wallets"></NoElements>;
